angular.module('aprima-bridge').factory('XamarinBridge',
    ['$timeout', '_', 'HostedBridgeService', function ($timeout, _, HostedBridgeService) {
        'use strict';

        var getBridge = function () {
            return HostedBridgeService;
        };

        return {
            fireEvent: function fireEvent(eventName, data){
                getBridge().fireEvent(eventName, data);
            },
            navigate: function (appRoute, route, transition) {
                try {
                    getBridge().fireEvent('navigate', {
                        command: {
                            Route: route,
                            Page: '/index.html',
                            State: appRoute.state,
                            ListUiControlName: appRoute.listUiControlName,
                            Options: JSON.stringify(transition.opts),
                            PageOptions: JSON.stringify(transition.pageOpts)
                        }
                    });
                }
                catch (e) {
                    console.warn(e.message);
                }
            },

            onNavigate: function (fn) {
                getBridge().addEventListener('navigate', fn);
            },

            on: function (event, $scope, fn) {
                //handles events received from the getBridge() and removes the event when the scope is destroyed

                var handlerForScope = function (args) {

                    function handler () {
                        fn(args);
                    }

                    if($scope && $scope.$evalAsync) {
                        $scope.$evalAsync(function() {
                            handler();
                        });
                    }
                    else {
                        handler();
                    }
                };

                var removeEventListener = function(){
                    getBridge().removeEventListener(event, handlerForScope);

                    //only allow this function to be called once
                    removeEventListener = angular.noop;
                };

                if ($scope) {
                    $scope.$on('$destroy', function () {
                        removeEventListener();
                    });
                }

                getBridge().addEventListener(event, handlerForScope);

                return removeEventListener;
            },

            changeUserInfo: function (jsonWebToken, clientUrl, userId) {
                getBridge().fireEvent('changeUserInfo', {UserInfo: {
                    JsonWebToken: jsonWebToken,
                    ClientUrl: clientUrl,
                    UserId: userId
                }});
            },

            updateSettings: function (s) {
                var settings = [];
                if (_.isArray(s) === false) {
                    settings.push(s);
                }
                else {
                    settings = s;
                }

                getBridge().fireEvent('updateSettings', {settings: settings});
            },

            setupPage: function (nativeSettings) {
                getBridge().fireEvent('setupPage', nativeSettings);
            },
            setHeaderMode: function (mode) {
                getBridge().fireEvent('setHeaderMode', {
                    mode: mode
                });
            },

            createModalAlert: function (args) {
                getBridge().fireEvent('createModalAlert', args);
            },

            closeSearchHeader: function () {
                getBridge().fireEvent('closeSearchHeader', {});
            },
            goBack: function () {
                getBridge().fireEvent('goBack', {});
            },
            pageFinished: function () {
                $timeout(function(){
                    getBridge().fireEvent('pagefinished', {});
                }, 0);
            },
            pickMedia: function (id, buttonText) {
                getBridge().fireEvent('pickMedia', {Id: id, SaveButtonText: buttonText});
            },
            updateBadges: function() {
                getBridge().fireEvent('updateBadges', {});
            },
            updatePageIndicator: function(itemCount, currentItem, useLastHeader) {
                getBridge().fireEvent('updatePageIndicator', { itemCount: itemCount, currentItem: currentItem, useLastHeader: useLastHeader});
            },           
            overriddenMessages: function(args) {                
                getBridge().fireEvent('overriddenMessages', {fileKey: args[1], logData: JSON.stringify([].slice.call(args, 2)) });
            },
            debugModeToggled: function(args){
                getBridge().fireEvent('debugModeToggled', {debugMessage: args[0],fileKey: args[1],  extraInfo: JSON.stringify([].slice.call(args,2))});
            },
            updateInactivityTimeout: function(userInactivityTimeout) {
                getBridge().fireEvent('updateInactivityTimeout', { timeout: userInactivityTimeout });
            },
            scanBarcode: function(id) {
                getBridge().fireEvent('scanBarcode', {Id: id});
            },
        };
    }]);
